import downloadBlob from './downloadBlob';

interface DownloadXLSXProps {
  data: Uint8Array;
  filename?: string;
}

const downloadXLSX = ({ data, filename = 'download.xlsx' }: DownloadXLSXProps) =>
  downloadBlob({
    blob: new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8',
    }),
    filename,
  });

export default downloadXLSX;
